import { GlobalToastManager } from '../../providers/GlobalToastManager';
import type { ToastProps, ToastPropsBase } from './useToasts';

/** Return common toast dispatching callbacks  */
export function createToastHooks<T extends ToastPropsBase>(manager: InstanceType<typeof GlobalToastManager<T>>) {
  return {
    add: (...args: Parameters<typeof manager.addToast>) => manager.addToast(...args),
    remove: (...args: Parameters<typeof manager.removeToast>) => manager.removeToast(...args),
    clearAll: (...args: Parameters<typeof manager.clearToasts>) => manager.clearToasts(...args),
  };
}

/**
 * Global toast manager instance for use in non-React contexts.
 * Use this directly in RTK Query endpoints, thunks, or utility functions where React hooks are not available.
 * For React components, use the `useGlobalToasts()` hook instead.
 */
const globalToastManagerUI = new GlobalToastManager<ToastProps>('ui');
const uiToastHooks = createToastHooks<ToastProps>(globalToastManagerUI);

export { globalToastManagerUI };

// Return ths toast functions for the global toasts and app inbox toasts - if you ne
export const useGlobalToasts = () => uiToastHooks;
